/* tslint:disable */
/* eslint-disable */
/**
 * New Notifier Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: kohestanimahdi@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { SendMessageViaMassengerRequest } from '../model';
// @ts-ignore
import { SocialMediaAccountsResponse } from '../model';
/**
 * SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDelete - axios parameter creator
 * 
 * @param {number} [id] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteAxiosParamCreator (id?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SocialMedia/DeleteSocialMediaAccount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (id !== undefined) {
        localVarQueryParameter['id'] = id;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SocialMediaApiApiSocialMediaGet - axios parameter creator
 * 
 * @summary get the links of joining social medias
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SocialMediaApiApiSocialMediaGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SocialMedia`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SocialMediaApiApiSocialMediaSendMessagePost - axios parameter creator
 * 
 * @summary send message to telegram
 * @param {SendMessageViaMassengerRequest} [sendMessageViaMassengerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SocialMediaApiApiSocialMediaSendMessagePostAxiosParamCreator (sendMessageViaMassengerRequest?: SendMessageViaMassengerRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SocialMedia/SendMessage`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(sendMessageViaMassengerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiSocialMediaDeleteSocialMediaAccountDelete operation in SocialMediaApi.
 * @export
 * @interface SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteRequest
 */
export interface SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDelete
     */
    readonly id?: number
}

/**
 * Request parameters for apiSocialMediaGet operation in SocialMediaApi.
 * @export
 * @interface SocialMediaApiApiSocialMediaGetRequest
 */
export interface SocialMediaApiApiSocialMediaGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SocialMediaApiApiSocialMediaGet
     */
    readonly userId?: number
}

/**
 * Request parameters for apiSocialMediaSendMessagePost operation in SocialMediaApi.
 * @export
 * @interface SocialMediaApiApiSocialMediaSendMessagePostRequest
 */
export interface SocialMediaApiApiSocialMediaSendMessagePostRequest {
    /**
     * 
     * @type {SendMessageViaMassengerRequest}
     * @memberof SocialMediaApiApiSocialMediaSendMessagePost
     */
    readonly sendMessageViaMassengerRequest?: SendMessageViaMassengerRequest
}

/**
* 
* @param {SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDelete(requestParameters: SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SocialMediaApiApiSocialMediaDeleteSocialMediaAccountDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get the links of joining social medias
* @param {SocialMediaApiApiSocialMediaGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SocialMediaApiApiSocialMediaGet(requestParameters: SocialMediaApiApiSocialMediaGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SocialMediaApiApiSocialMediaGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<SocialMediaAccountsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary send message to telegram
* @param {SocialMediaApiApiSocialMediaSendMessagePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SocialMediaApiApiSocialMediaSendMessagePost(requestParameters: SocialMediaApiApiSocialMediaSendMessagePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SocialMediaApiApiSocialMediaSendMessagePostAxiosParamCreator(requestParameters.sendMessageViaMassengerRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
